export default "__VITE_ASSET__CvxXoTlk__"